export default "__VITE_ASSET__3fc0a020__"